export default "__VITE_ASSET__BvxJPMF1__"